import * as React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import { useAuth } from "hooks/useAuth";
import { AuthLayout } from "./AuthLayout";
import { AuthFlowProvider, useAuthFlow } from "./data";
import ForgotStep from "./ForgotStep";
import ResetStep from "./ResetStep";
import SignInStep from "./SignInStep";
import { AUTH_PATHS } from "./types";
import VerifyStep from "./VerifyStep";

/**
 * Sign in, WhatsApp code, forgot password and reset password: one flow inside one layout. Each
 * step has its own URL (so Back works), shares the flow state, and fades in place when it changes.
 */
const AuthSteps = () => {
  const location = useLocation();
  const { status } = useAuth();
  const { returnPath } = useAuthFlow();

  // Already signed in (or just finished the code step): continue to the app.
  if (status !== "anonymous") {
    return <Redirect to={returnPath} />;
  }

  return (
    <AuthLayout>
      <div
        key={location.pathname}
        className="animate-in fade-in-0 slide-in-from-bottom-2 duration-300 ease-standard motion-reduce:animate-none"
      >
        <Switch location={location}>
          <Route exact path={AUTH_PATHS.signIn} component={SignInStep} />
          <Route exact path={AUTH_PATHS.verify} component={VerifyStep} />
          <Route exact path={AUTH_PATHS.forgot} component={ForgotStep} />
          <Route exact path={AUTH_PATHS.reset} component={ResetStep} />
          <Redirect to={AUTH_PATHS.signIn} />
        </Switch>
      </div>
    </AuthLayout>
  );
};

const AuthFlow = () => (
  <AuthFlowProvider>
    <AuthSteps />
  </AuthFlowProvider>
);

export default AuthFlow;
